import React, { useEffect, useState } from "react";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import { ChevronDown } from "lucide-react";
import { apiCallGeneric } from "../service/api-service";
import fill_chevron_down from "../../assets/png/fill_chevron_down.png";
import close from "../../assets/png/close_filter.png";
import "./common.css";
import "../quotation/quotation.css";
const CommonNewDropdown = ({
  apiUrl,
  placeholder = "Select",
  onSelect,
  value,
  searchView = false,
}) => {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch from API

  const fetchData = async () => {
    setLoading(true);

    try {
      if (apiUrl) {
        const response = await apiCallGeneric("GET", apiUrl, null, {
          params: { term: searchTerm },
        });

        if (response.status === 200 && response.data.success) {
          setItems(response.data.suggestionlist);
        } else {
          setItems([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchData();
  }, []);

  // Sync selected value from parent
  useEffect(() => {
    setSelected(value);
  }, [value]);

  // Handle search (hit API)
  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    fetchData(term); // 🔥 hit API directly on search
  };

  // Handle selection
  const handleSelect = (item) => {
    setSelected(item);
    if (onSelect) onSelect(item);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className={`${searchView === false
          ? "bg-transparent text-black"
          : "bg-white text-purple assigned-dropdown rounded-4 px-4"
          }  d-flex justify-content-between dp-toggle`}
        style={{ width: "100%", height: "36px" }}
      >
        <span
          className="fs-13 fw-500"
          style={{
            extOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            color: selected ? "#212129" : "#888888",
          }}
        >
          {selected ? selected.label : placeholder}
        </span>
        <span className="text-black">
          {searchView === false ? (
            <ChevronDown />
          ) : (
            <img src={fill_chevron_down} alt="chev down" />
          )}
          {searchView === true && selected ? (
            <img onClick={() => handleSelect(null)} src={close} alt="x" />
          ) : (
            ""
          )}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-2 fs-13 fw-500"
        // popperConfig={{
        //   strategy: "fixed",
        //   modifiers: [
        //     {
        //       name: "computeStyles",
        //       options: { adaptive: true },
        //     },
        //     {
        //       name: "sameWidth",
        //       enabled: true,
        //       phase: "beforeWrite",
        //       requires: ["computeStyles"],
        //       fn: ({ state }) => {
        //         state.styles.popper.width = `${state.rects.reference.width}px`;
        //       },
        //     },
        //     {
        //       name: "applyStyles",
        //       enabled: true,
        //       fn: ({ state }) => {
        //         // Force update position
        //         Object.assign(state.styles.popper, state.styles.popper);
        //       },
        //     },
        //   ],
        // }}
        style={{
          maxHeight: "250px",
          overflowY: "auto",
          minWidth: "200px",
          zIndex: 99999,
        }}
      >
        {/* Search box */}
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearch}
          className="mb-2 fs-13 fw-500"
        />

        {/* Loading spinner */}
        {loading && (
          <div className="px-2 text-muted">
            <Spinner size="sm" /> Loading...
          </div>
        )}

        {/* Dropdown items */}
        {!loading && items.length > 0 ? (
          items.map((item) => (
            <Dropdown.Item
              key={item.value}
              onClick={() => handleSelect(item)}
              className="text-black fs-15 fw-500"
            >
              {item.label}
            </Dropdown.Item>
          ))
        ) : !loading ? (
          <div className="px-2 text-muted">No results found</div>
        ) : null}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CommonNewDropdown;
